module.exports = __webpack_public_path__ + "static/media/tier-9.2034f443.jpg";